<script setup>
import AristLogo from '@/components/shared/core/AristLogo.vue'
import {useEmployeePortal} from '@/composables/use-employee-portal.js'

//Composables
const {slug, isSlugValid} = useEmployeePortal()
</script>

<template>
  <div :class="$style.logoWrapper">
    <img
      v-if="slug && isSlugValid"
      :src="`/logos/logo-${slug}.svg`"
      :class="$style.organizationLogo"
      alt="Logo"
      decoding="async"
    >
    <AristLogo
      v-else
      :class="$style.aristLogo"
    />
  </div>
</template>

<style module lang="scss">
.logoWrapper {
  font-size: 0;
  text-align: center;
  margin-bottom: 1.5rem;
}
.organizationLogo {
  max-height: 5rem;
  max-width: 12rem;
}
.aristLogo {
  height: 3rem;
}
</style>
